<template>
    <header class="header cr-p4">
        <div class="header-top">
            <div class="badge cr-ptb1 cr-plr3" :data-testing="`${prefix}-badge`">{{ badge }}</div>
            <div v-if="$slots.actions" class="header-actions" data-testing="menu-header-actions">
                <slot name="actions"/>
            </div>
        </div>
        <h1 class="title cr-m0" :data-testing="`${prefix}-title`">{{ titleMain }}<span class="accent">{{ titleAccent }}</span></h1>
    </header>
</template>

<style scoped>
.header
{
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    gap: 0.75rem;
    text-align: center;
}

.header-top
{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: var(--cr-main-content-width);
    position: relative;
}

.header-actions
{
    position: absolute;
    right: 0;
}

.badge
{
    font-size: 0.75rem;
    font-weight: 700;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    color: var(--cr-splash-accent);
    border: 1px solid var(--cr-splash-accent-subtle);
    border-radius: var(--cr-pill-button-border-radius);
}

.title
{
    font-size: clamp(2rem, 5vw, 3.5rem);
    font-weight: 800;
    color: var(--cr-splash-text);
    letter-spacing: 0.04em;
    line-height: 1;
}

.accent
{
    color: var(--cr-splash-accent);
}
</style>

<script setup lang="ts">
defineProps<
{
    prefix: string;
    badge: string;
    titleMain: string;
    titleAccent: string;
}>();
</script>
